<template>
  <div class="index">
    <!-- 标题栏 -->
    <div class="page">
      <div class="header">
        <img src="img/index/img_bg.png" />
        <div class="kqb-tools disp-flex">
          <!-- <div class="kqb-location disp-flex">
            <div class="ellipsis">湖南湘西</div>
            <i class="iconfont icon-arrow-right-thin"></i>
          </div> -->
          <div class="kqb-search-bar">
            <img src="img/index/icon_search.png" class="icon_search" />
            <input placeholder-class="placeholder" type="text" placeholder="请输入课程关键字" />
          </div>
        </div>
      </div>
      <div class="nav-bar">
        <div class="nav-bar-item" @click="pageJumpCate('/curriculumSchedule?from=yixue')">
          <img src="img/index/img_01.png" />
          <div>已学</div>
        </div>
        <div class="nav-bar-item" @click="pageJumpCate('/curriculumSchedule?from=mianfei')">
          <img src="img/index/img_02.png" />
          <div>免费</div>
        </div>
        <!-- <div v-if="isVip == 0" class="nav-bar-item" @click="showModal=true">
          <img src="img/index/img_03.png" />
          <div>VIP</div>
        </div>
        <div v-if="isVip == 1" class="nav-bar-item" @click="pageJumpCate('/curriculumSchedule?from=vip')">
          <img src="img/index/img_03.png" />
          <div>VIP</div>
        </div> -->
        <div class="nav-bar-item" @click="showVipGood()">
          <img src="img/index/img_03.png" />
          <div>VIP</div>
        </div>
        <div class="nav-bar-item" @click="pageJumpCate('/classification')">
          <img src="img/index/img_04.png" />
          <div>分类</div>
        </div>
      </div>
      <div class="section">
        <div class="section-title disp-flex-between">
          <div>课程推荐</div>
          <div class="more disp-flex">
            <div>更多</div>
            <div class="icon"></div>
          </div>
        </div>
        <div class="kqb-media-list audio-recommend">
          <div class="kqb-media-item" @click="pageJump('/mediaRecommendationDetail',audioRecommendations)">
            <div class="kqb-media-group">
              <img v-lazy="audioRecommendations.goodsFirstImg" />
            </div>
            <div class="kqb-media-inner">
              <div class="kqb-media-title ellipsis">{{audioRecommendations.goodsLongName}}</div>
              <div class="kqb-media-desc ellipsis"></div>
              <div class="kqb-media-footer">
                <div class="fc-FF1A1A">
                  <text class="fc-30">{{audioRecommendations.goodsQuantity}}集</text>
                </div>
                <button class="kqb-btn bgC-FFCC00-FFCC00">学习</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="section">
        <div class="section-title disp-flex-between" style="margin-bottom: 3px;">
          <div>热播课程</div>
          <div class="more disp-flex">
            <div>更多</div>
            <div class="icon"></div>
          </div>
        </div>
        <div class="kqb-media-list hotclass">
          <div class="kqb-media-item" v-for="(item,index) in hotSubjectList" :key="index" @click="pageJump('/mediaRecommendationDetail',item)">
            <img v-lazy="item.goodsFirstImg" class="kqb-media-object" />
            <div class="kqb-media-inner">
              <div class="kqb-media-title ellipsis">{{item.goodsLongName}}</div>
              <div class="kqb-media-desc ellipsis"></div>
              <div class="kqb-media-label">主讲人：{{item.goodsLecturerName}}</div>
              <div class="kqb-media-footer fc-FF1A1A" v-if="item.goodsIsVip == 1">{{item.goodsQuantity}}集/VIP</div>
              <div class="kqb-media-footer fc-F82E3D" v-else>
                <div class="fc-FF1A1A">{{item.goodsQuantity}}集</div>
                <div class="fc-000">{{item.goodsQuantity}}人学习</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="section">
        <div class="section-title">猜你喜欢</div>
        <div class="kqb-media-list doyoulike">
          <div class="kqb-media-item" v-for="(item,index) in guessFavoriteList" :key="index" @click="pageJump('/mediaRecommendationDetail',item)">
            <div class="kqb-media-object-group">
              <img v-lazy="item.goodsFirstImg" class="kqb-media-object" />
              <div class="mask">{{item.countStudy}}人已抢先学习啦</div>
            </div>
            <div class="kqb-media-inner">
              <div class="kqb-media-footer">
                <div class="fc-000">{{item.goodsLongName}}</div>
                <div class="fc-FF1A1A">10集<label v-if="item.goodsIsVip == 1">/VIP</label></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--modal-->
      <div class="modal" v-if="showModal" @touchmove.prevent>
        <div class="BGurl-modal">
          <img src="img/common/modal/img_artword.png" class="artword" />
          <div class="fc-875940">您将享受如下特权</div>
          <div class="nav-bar" style="padding:0;background: transparent;box-shadow: none;">
            <div class="nav-bar-item" data-uri="/pages/index/curriculum_schedule/curriculum_schedule">
              <img src="img/user/vip_privilege/img_01.png" />
              <div>音频畅听</div>
            </div>
            <div class="nav-bar-item" data-uri="/pages/index/curriculum_schedule/curriculum_schedule">
              <img src="img/user/vip_privilege/img_02.png" />
              <div>1天仅需1元</div>
            </div>
            <div class="nav-bar-item" data-uri="/pages/index/curriculum_schedule/curriculum_schedule">
              <img src="img/user/vip_privilege/img_03.png" />
              <div>邀请码激活</div>
            </div>
          </div>
          <!-- <button class="kqb-btn fc-78482F" @click="pageJumpCate('/user')">
            请通过个人中心申请邀请码
          </button> -->
          <!-- <button class="kqb-btn fc-78482F" @click="commitPay()"> -->
          <button class="kqb-btn fc-78482F" @click="navigateToPay()">
            支付365成为会员
          </button>
          <i class="iconfont icon-canel2" @click="showModal=false"></i>
        </div>
      </div>
    </div>
    <!-- 底部navbar -->
    <van-tabbar v-model="active" active-color="#4A4846" inactive-color="#9C9B9B">
      <van-tabbar-item :name="item.name" @click="switchTab(item)" v-for="(item,index) in navbars" :key="index">
        <span v-text="item.text" style="font-size:14px"></span>
        <img slot="icon" slot-scope="props" :src="props.active ? item.active : item.normal" />
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>
<script>
import wx from 'weixin-js-sdk'
export default {
  name: 'index',
  data () {
    return {
      active: 0, // 当前展示哪个tab
      navbars: [
        {
          text: 'VIP区',
          normal: './img/common/tabs/tab1.png',
          active: './img/common/tabs/tab1_HL.png'
        }, {
          text: '专辑区',
          normal: './img/common/tabs/tab2.png',
          active: './img/common/tabs/tab2_HL.png'
        },
        {
          text: '我的',
          normal: './img/common/tabs/tab3.png',
          active: './img/common/tabs/tab3_HL.png'
        }
      ],
      isOpenVipModular: false,
      showModal: false, // 是否展示弹窗
      audioRecommendations: {}, // 音频推荐数据
      hotSubjectList: [], // 热门课程数据
      guessFavoriteList: [], // 猜你喜欢
      isVip: 0,
      storeId: '',
      userId: '',
      isMiniProgram: true
    }
  },
  created () {
    const thisObj = this
    thisObj.onLoad()
    // 调用热门课程数据获取方法
    // thisObj.getHotSubjectInfo()
    // 调用猜你喜欢数据获取方法
    // thisObj.getFavoriteVedios()
    this.checkIsFromMiniProgram(function (res) {
      thisObj.isMiniProgram = res
    })
  },
  methods: {
    onLoad: function () {
      var personInfo = {}
      var personId = this.$util.getUrlParam('personId')
      var personNickName = this.$util.getUrlParam('personNickName')
      var personToken = this.$util.getUrlParam('personToken')
      var personMobileNo = this.$util.getUrlParam('personMobileNo')
      var personHeadImg = this.$util.getUrlParam('personHeadImg')
      var personLoginTimeStamp = this.$util.getUrlParam('personLoginTimeStamp')
      var personIsVip = this.$util.getUrlParam('personIsVip')
      var personOpenId = this.$util.getUrlParam('personOpenId')
      var storeId = this.$util.getUrlParam('storeId')
      let value = this.$util.getUrlParam('code')
      this.storeId = storeId
      this.userId = personId
      if (personId != null) {
        personInfo['personAccountInfoId'] = personId
        personInfo['personAccountToken'] = personToken
        personInfo['personLoginTimeStamp'] = personLoginTimeStamp
        personInfo['personAccountInfoDsfOpenId'] = personOpenId
        personInfo['personAccountInfoHeadImg'] = personHeadImg
        personInfo['personAccountInfoNickName'] = personNickName
        personInfo['personMobileNo'] = personMobileNo
        personInfo['personIsVip'] = personIsVip
        personInfo['storeId'] = storeId
        this.isVip = parseInt(personIsVip)
        this.$root.userInfo = personInfo
        this.$root.isLogin = true
        const thisObj = this
        // 调用热门课程数据获取方法
        thisObj.getHotSubjectInfo()
        // 调用猜你喜欢数据获取方法
        thisObj.getFavoriteVedios()
      } else if (this.$util.getUrlParam('isUser') === '1') {
        const thisObj = this
        let countS = this.$util.getUrlParam('cS')
        thisObj.goodsId = this.$util.getUrlParam('gId')
        thisObj.countStudy = countS
        //   thisObj.isNew = true
        let upId = this.$util.getUrlParam('upId')
        let apNam = this.$util.getUrlParam('aN')
        let isUserInfo = apNam + '!' + upId + '!' + thisObj.goodsId + '!' + countS
        let paIsInfo = escape(isUserInfo)
        window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxd5ba93934e0b0e5b&redirect_uri=https://zklm.kequbang.com?isUser=' + paIsInfo + '&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect'
      } else if (value !== null) {
        var that = this
        const thisObj = this
        let paInfo = this.$util.getUrlParam('isUser')
        paInfo = unescape(paInfo)
        let infos = paInfo.split('!')
        thisObj.storeId = infos[0]
        let upUserId = infos[1]
        let goodsId = infos[2]
        let countStudy = infos[3]
        let usInfos
        if (value != null) {
          that.$api.post(that.requestUrl + '/weixin/get/person/info?fromDevice=h5', { 'weixinCode': value }).then(res => {
            const userInfo = res.resultData
            this.$root.userInfo = userInfo
            usInfos = userInfo
            this.$root.isLogin = true
            var wx = require('weixin-js-sdk')
            var href = window.location.href
            var urlConfig = that.requestUrl + '/weixin/get/js/config?fromDevice=h5'
            that.$api.post(urlConfig, { 'url': href }).then(res => {
              if (res.resultCode === 200 && res.success) {
                wx.config({
                  debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                  appId: res.resultData.appid, // 必填，公众号的唯一标识
                  timestamp: res.resultData.timestamp, // 必填，生成签名的时间戳
                  nonceStr: res.resultData.noncestr, // 必填，生成签名的随机串
                  signature: res.resultData.sign, // 必填，签名
                  jsApiList: ['checkJsApi', 'chooseWXPay'] // 必填，需要使用的JS接口列表/person/login
                })
              }
            })
            that.$api.post(that.requestUrl + '/person/login/weixin', {
              'storeId': thisObj.storeId,
              'wxOpenId': usInfos.personAccountInfoDsfOpenId,
              'wxHeadImg': usInfos.personAccountInfoDsfHeadImg,
              'wxCity': usInfos.personAccountInfoDsfCity,
              'wxCountry': usInfos.personAccountInfoDsfCountry,
              'wxNickName': usInfos.personAccountInfoDsfNickName,
              'wxProvince': usInfos.personAccountInfoDsfProvince,
              'wxPrivilege': '',
              'wxSex': usInfos.personAccountInfoSex,
              'wxUnionid': usInfos.personAccountInfoDsfUnionid,
              'mobileNo': '',
              'mobileCode': '',
              'personParentId': upUserId,
              'fromAppName': '客渠邦服务号'
            }).then(res => {
              const userInfo = res.resultData
              this.$root.userInfo = userInfo
              this.$root.isLogin = true
            })
          })
        } else {
          //   window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxd5ba93934e0b0e5b&redirect_uri=https://zklm.kequbang.com?isUser=' + thisObj.storeId + '!' + upUserId + '!' + that.goodsId + '!' + that.countStudy + '&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect'
        }
        this.pageNewJump(thisObj.storeId, upUserId, goodsId, countStudy)
      }
    },
    // 底部tab切换
    switchTab (item) {
      const thisObj = this
      let router = ''
      switch (item.text) {
        case 'VIP区':
          router = '/'
          break
        case '专辑区':
          // router = '/alliance'
          thisObj.$util.requetServerError('升级中,即将上线')
          break
        default:
          router = '/user'
      }
      if (item.text === '专辑区') { return }
      thisObj.$router.push(router)
    },
    // 获取热门课程数据方法
    getHotSubjectInfo () {
      const thisObj = this
      var storeId = this.$root.userInfo.storeId
      thisObj.$api.get(thisObj.requestUrl + '/knowledge/goods/info/getKnowledgeHotSubject?fromDevice=h5&storeId=' + storeId, {}).then(res => {
        // console.log(res)
        if (res.resultCode === 200 && res.success) {
          if (res.resultData.length <= 5) {
            thisObj.hotSubjectList = res.resultData
          } else {
            let hotLset = []
            for (let i = 0; i <= 5; i++) {
              hotLset.push(res.resultData[i])
            }
            thisObj.hotSubjectList = hotLset
          }
          thisObj.audioRecommendations = thisObj.hotSubjectList[0]
        } else {
          thisObj.$util.requetServerError(res.resultMsg)
        }
      }).catch(function (error) {
        thisObj.$util.requetServerError(error)
      })
    },
    showVipGood: function () {
      const thisObj = this
      var person = this.$root.userInfo
      thisObj.$api.get(thisObj.requestUrl + '/auth/knowledge/vip/info/get?fromDevice=h5&knowledgeOpenPersonId=' + person.personAccountInfoId, {}).then(res => {
        // console.log(res)
        if (res.resultCode === 200 && res.success) {
          if (res.resultData / 1 === 1) {
            thisObj.pageJumpCate('/curriculumSchedule?from=vip')
          } else {
            this.showModal = true
          }
        } else {
          thisObj.$util.requetServerError(res.resultMsg)
        }
      }).catch(function (error) {
        thisObj.$util.requetServerError(error)
      })
    },
    // 获取猜你喜欢数据方法
    getFavoriteVedios: function () {
      const thisObj = this
      var storeId = this.$root.userInfo.storeId
      thisObj.$api.get(thisObj.requestUrl + '/knowledge/goods/info/getFavoriteVedios?fromDevice=h5&storeId=' + storeId, {}).then(res => {
        // console.log(res)
        if (res.resultCode === 200 && res.success) {
          if (res.resultData.length <= 5) {
            thisObj.guessFavoriteList = res.resultData
          } else {
            let guessFavoriteList = []
            for (let i = 0; i <= 5; i++) {
              guessFavoriteList.push(res.resultData[i])
            }
            thisObj.guessFavoriteList = guessFavoriteList
          }
        } else {
          thisObj.$util.requetServerError(res.resultMsg)
        }
      }).catch(function (error) {
        thisObj.$util.requetServerError(error)
      })
    },
    // 二维码进入页面跳转
    pageNewJump (storeId, upUserId, goodsId, countStudy) {
      const thisObj = this
      let eUrl = '/mediaRecommendationDetail'
      let queryData = {
        storeId: storeId,
        upUserId: upUserId,
        isUser: '2',
        goodsId: goodsId,
        countStudy: countStudy
      }
      thisObj.$router.push({
        path: eUrl,
        query: queryData
      })
    },
    // 页面跳转
    pageJump (uri, item) {
      const thisObj = this
      let queryData = {
        fileType: item.goodsType,
        goodsId: item.goodsId,
        goodsName: item.goodsLongName,
        goodsLecturerName: item.goodsLecturerName,
        goodsBriefDesc: item.goodsBriefDesc,
        goodsLecturerDesc: item.goodsLecturerDesc,
        goodsQuantity: item.goodsQuantity,
        countStudy: item.countStudy,
        goodsNo: item.goodsNo,
        goodsDetailImgs: item.goodsNativeDetailDesc,
        goodsFirstImg: item.goodsFirstImg,
        goodsIsVip: item.goodsIsVip,
        isUser: '0',
        storeId: this.storeId,
        userId: this.userId
      }
      thisObj.$router.push({
        path: uri,
        query: queryData
      })
    },
    // 页面跳转
    pageJumpCate (uri) {
      const thisObj = this
      let queryData = {
      }
      thisObj.$router.push({
        path: uri,
        query: queryData
      })
    },
    // 支付会员费用
    commitPay () {
      var that = this
      var person = this.$root.userInfo
      var isLogin = that.$root.isLogin = true
      if (!isLogin) {
        that.$util.requetServerError('亲,你还没有登录,请先登录')
      } else {
        var wx = require('weixin-js-sdk')
        var href = window.location.href
        var urlConfig = that.requestUrl + '/weixin/get/js/config?fromDevice=h5'
        // var urlConfig = that.requestUrl + '/weixin/get/knowledge/config?fromDevice=h5'
        that.$api.post(urlConfig, { 'url': href, 'storeId': person.storeId }).then(res => {
          console.log(res)
          if (res.resultCode === 200 && res.success) {
            wx.config({
              debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
              appId: res.resultData.appid, // 必填，公众号的唯一标识
              timestamp: res.resultData.timestamp, // 必填，生成签名的时间戳
              nonceStr: res.resultData.noncestr, // 必填，生成签名的随机串
              signature: res.resultData.sign, // 必填，签名
              jsApiList: ['checkJsApi', 'chooseWXPay'] // 必填，需要使用的JS接口列表
            })
            var url = that.requestUrl + '/auth/knowledge/vip/official/confirm/pay?fromDevice=h5&personId=' + person.personAccountInfoId + '&storeId=' + person.storeId + '&personToken=' + person.personAccountToken + '&loginTimestamp=' + person.personLoginTimeStamp + '&personOpenId=' + person.personAccountInfoDsfOpenId
            // var url = that.requestUrl + '/auth/knowledge/vip/official/confirm/pay?fromDevice=h5&personId=' + '' + '&storeId=' + 'STOREINFOFBCB01621A0AFE62F036E8C9D0B01ABC' + '&personToken=' + '' + '&loginTimestamp=' + '' + '&personOpenId=' + ''
            that.$api.get(url, {}).then(result => {
              console.log(result)
              if (result.resultCode === 200 && result.success) {
                wx.chooseWXPay({
                  timestamp: result.resultData.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
                  nonceStr: result.resultData.nonceStr, // 支付签名随机串，不长于 32 位
                  package: result.resultData.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
                  signType: result.resultData.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
                  paySign: result.resultData.sign, // 支付签名
                  success: function (res) {
                    // 支付成功后的回调函数
                    person.isVip = 1
                    this.isVip = 1
                    this.$root.userInfo = person
                    that.$util.showSuccessMsg('开通会员成功')
                  },
                  cancel: function () {
                    alert('支付已取消')
                  },
                  error: function (e) {
                  }
                })
              } else {
                that.$util.requetServerError(res.resultMsg)
              }
            }).catch(function (error) {
              that.$util.requetServerError(error)
            })
          } else {
            that.$util.requetServerError(res.resultMsg)
          }
        })
      }
    },
    // 跳转小程序支付
    // 判断来源是否是小程序
    checkIsFromMiniProgram: function (callback) {
      wx.miniProgram.getEnv(function (res) {
        console.log('minprogram:' + res.miniprogram) // true
        //  alert(JSON.stringify(res));
        if (res.miniprogram === true) {
          // eslint-disable-next-line standard/no-callback-literal
          callback && callback(true)
          // alert('isMiniprogram:' + res.miniprogram);
        } else {
          // eslint-disable-next-line standard/no-callback-literal
          callback && callback(false)
          // alert("========公众号");
        }
      })
    },
    // 跳转到小程序
    navigateToMiniProgram: function (payParam) {
      const url =
        '/pages/wxPay/wxPay?payParam=' + encodeURIComponent(payParam)
      //   alert('url:' + url)
      wx.miniProgram.navigateTo({
        url: url
      })
    },
    // 小程序和公众号跳转不同页面
    navigateToPay: function () {
      //   if (this.isMiniProgram === true) {
      // alert('小程序')
      // 由后台协商好返回的数据格式，该代码仅供参考，不能实际使用
      var that = this
      var person = this.$root.userInfo
      //   var isLogin = that.$root.isLogin = true
      var url = that.requestUrl + '/auth/knowledge/vip/knowledge/confirm/pay?fromDevice=h5&personId=' + person.personAccountInfoId + '&storeId=' + person.storeId + '&personToken=' + person.personAccountToken + '&loginTimestamp=' + person.personLoginTimeStamp + '&personOpenId=' + person.personAccountInfoDsfOpenId
      // var url = that.requestUrl + '/auth/knowledge/vip/official/confirm/pay?fromDevice=h5&personId=' + '' + '&storeId=' + 'STOREINFOFBCB01621A0AFE62F036E8C9D0B01ABC' + '&personToken=' + '' + '&loginTimestamp=' + '' + '&personOpenId=' + ''
      that.$api.get(url, {}).then(result => {
        console.log(result)
        if (result.resultCode === 200 && result.success) {
          const payParam = {
            appId: result.resultData.appId,
            package: result.resultData.package,
            paySign: result.resultData.sign,
            signType: 'MD5',
            timeStamp: result.resultData.timeStamp,
            nonceStr: result.resultData.nonceStr
          }
          this.navigateToMiniProgram(JSON.stringify(payParam))
        } else {
          that.$util.showSuccessMsg(result.resultMsg)
        }
      }).catch(function (error) {
        that.$util.requetServerError(error)
      })
    }
  }
}
</script>
<style lang="css" scoped>
.fc-78482F {
  color: #78482f;
}
.page {
  overflow-x: hidden;
  background: #fff;
}

.header {
  width: 100%;
  height: 484px;
  margin: 0;
}

.header > img {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
}

.kqb-tools {
  margin: 0 33px 0 39px;
  padding: 44px 0 47px 0;
}

.kqb-tools .kqb-location {
  -webkit-align-items: center;
  align-items: center;
  width: 200px;
  height: 56px;
  margin: 0 24px 0 0;
  font-size: 28px;
  font-family: Adobe Heiti Std;
  font-weight: normal;
  color: rgba(255, 255, 255, 1);
}

.kqb-tools .kqb-location .icon-arrow-right-thin {
  width: 30px;
  height: 30px;
  margin: -2px 0 0 28px;
  font-size: 32px;
  transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  /* IE 9 */
  -moz-transform: rotate(90deg);
  /* Firefox */
  -webkit-transform: rotate(90deg);
  /* Safari 和 Chrome */
  -o-transform: rotate(90deg);
  /* Opera */
}

.kqb-search-bar {
  /* width: 434px; */
  width: 100%;
  height: 56px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 0px 5px 1px rgba(4, 19, 57, 0.21);
  border-radius: 10px;
}

.kqb-search-bar .icon_search {
  position: absolute;
  left: 16px;
  top: 50%;
  width: 27px;
  height: 28px;
  transform: translate(0, -50%);
}

.kqb-search-bar input {
  height: 56px;
  line-height: 56px;
  padding: 0 36px 0 55px;
  font-size: 28px;
  border: 0;
}

.kqb-search-bar .placeholder {
  font-size: 28px;
  font-family: Adobe Heiti Std R;
  font-weight: normal;
  color: rgba(199, 199, 199, 1);
}

.time {
  color: rgb(19, 10, 10);
  font-size: 26px;
  width: 40px;
}

.time1 {
  color: rgb(19, 10, 10);
  font-size: 26px;
  width: 40px;
  margin-left: 92%;
  margin-top: -6%;
}

.nav-bar {
  display: flex;
  margin: -60px 43px 61px 43px;
  padding: 26px 0 30px 0;
  background: rgba(255, 255, 255, 1);
  box-shadow: 6px 6px 30px 0px rgba(58, 60, 62, 0.14);
  border-radius: 10px;
  box-sizing: border-box;
}

.nav-bar .nav-bar-item {
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  text-align: center;
  font-size: 24px;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
}

.nav-bar .nav-bar-item img {
  max-width: 80px;
  height: 80px;
  margin: 0 auto;
}

.nav-bar .nav-bar-item div {
  padding: 16px 0 0 0;
}

.bannerswipers {
  width: 100%;
  height: 377px;
  overflow: hidden;
}

.bannerswipers img {
  width: 100%;
  height: 100%;
  border-radius: 10px;
  display: block;
}

/*用来包裹所有的小圆点  */
.bannerdots {
  width: auto;
  height: auto;
  display: flex;
  flex-direction: row;
  position: absolute;
  right: 30px;
  bottom: 20px;
}

/*未选中时的小圆点样式 */
.bannerdot {
  width: 16px;
  height: 16px;
  margin-right: 26px;
  background-color: #d1d1ce;
  border-radius: 16px;
}

/*选中以后的小圆点样式  */
.banneractive {
  background-color: #d0021b;
}

.kqb-media-item {
  margin: 46px 0;
  box-shadow: 0px 0px 5px 1px rgba(4, 19, 57, 0.21);
  background: rgba(255, 255, 255, 1);
  border-radius: 10px;
}

.kqb-media-object {
  max-width: 200px;
}

.section-title {
  margin: 61px 43px 47px 43px;
  padding: 0 0 0 28px;
  font-size: 34px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  font-style: italic;
  color: rgba(51, 51, 51, 1);
}

.section-title:before {
  content: "";
  position: absolute;
  left: 0;
  top: 50%;
  width: 8px;
  height: 34px;
  background: rgba(249, 206, 23, 1);
  border-radius: 4px;
  transform: translate(0, -50%);
}

.section-title.disp-flex-between .more {
  align-self: flex-end;
  margin: 0 0 1px 0;
  font-size: 22px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  font-style: normal;
  color: rgba(51, 51, 51, 0.5);
}

.section-title.disp-flex-between .more div.icon {
  width: 22px;
  height: 22px;
  margin: 0 0 0 9px;
  background: rgba(205, 203, 206, 1);
  border-radius: 50%;
}

.section-title.disp-flex-between .more div.icon:before,
.section-title.disp-flex-between .more div.icon:after {
  content: "";
  position: absolute;
  top: 50%;
  right: 0;
  transform: translate(0, -50%);
}

.section-title.disp-flex-between .more div.icon:after {
  content: "\e602";
  font-family: "iconfont" !important;
  font-size: 15px;
  left: 50%;
  top: 50%;
  color: #fff;
  transform: translate(-50%, -50%);
}

/*音频组件*/
.kqb-audios {
  padding: 44px 60px 44px 49px;
  box-sizing: border-box;
  box-shadow: 0px 0px 5px 1px rgba(4, 19, 57, 0.21);
  border-radius: 14px;
  background: rgba(255, 255, 255, 1);
}

.kqb-audios .kqb-media-item {
  margin: 0;
  padding: 0;
  box-shadow: none;
}

.kqb-audios .kqb-media-item .kqb-media-title {
  font-size: 30px;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
}

.kqb-audios .kqb-media-item .kqb-media-object.circle {
  max-width: 87px;
  height: 87px;
}

.kqb-audios .kqb-media-item .kqb-media-footer {
  margin: 14px 0 0 0;
  font-size: 26px;
  font-family: MicrosoftYaHei;
  font-weight: 400;
}

.kqb-audios .kqb-media-tools {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 27px 0 0 0;
}

.kqb-audios .kqb-media-tools .icon-media-player,
.kqb-audios .kqb-media-tools .icon-media-stop {
  margin: 0 120px;
  font-size: 84px;
}

.kqb-audios .kqb-media-tools .icon-media-previous,
.kqb-audios .kqb-media-tools .icon-media-next {
  font-size: 60px;
}

/*进度条长度  */
.kqb-audios .slid {
  flex: 1;
  position: relative;
}

.kqb-audios slider {
  width: 100%;
  margin: 15px 0 0 16px;
}

/* 音频推荐 */
.audio-recommend.kqb-media-list {
  margin: 76px 43px 0 43px;
}

.audio-recommend.kqb-media-list .kqb-media-item {
  padding: 20px;
  box-shadow: 6px 6px 30px 0px rgba(58, 60, 62, 0.14);
}

.audio-recommend.kqb-media-list .kqb-media-item .kqb-media-group {
  -webkit-flex: 0 0 332px;
  flex: 0 0 332px;
  margin: -41px 0 0 0;
}

.audio-recommend.kqb-media-list .kqb-media-item .kqb-media-group img {
  max-width: 332px;
  min-width: 332px;
  width: 332px;
  height: 190px;
  border-radius: 10px;
}

.audio-recommend.kqb-media-list .kqb-media-item .kqb-media-inner {
  width: 45%;
  margin: 0 0 0 16px;
}

.audio-recommend.kqb-media-list
  .kqb-media-item
  .kqb-media-inner
  .kqb-media-title {
  font-size: 28px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
}

.audio-recommend.kqb-media-list
  .kqb-media-item
  .kqb-media-inner
  .kqb-media-desc {
  font-size: 22px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 0.7);
}

.audio-recommend.kqb-media-list
  .kqb-media-item
  .kqb-media-inner
  .kqb-media-footer
  .fc-FF1A1A {
  font-size: 22px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: rgba(255, 48, 26, 1);
}

.audio-recommend.kqb-media-list
  .kqb-media-item
  .kqb-media-inner
  .kqb-media-footer
  .fc-FF1A1A
  .fc-30 {
  font-size: 30px;
}

button.kqb-btn.bgC-FFCC00-FFCC00 {
  width: 127px;
  height: 44px;
  line-height: 44px;
  margin: 0;
  padding: 0;
  text-align: center;
  font-size: 26px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  background: linear-gradient(
    -70deg,
    rgba(255, 204, 0, 1),
    rgba(255, 221, 0, 1)
  );
  border-radius: 0px 22px 22px 28px;
  border: 0;
  box-shadow: none;
}

.doyoulike.kqb-media-list,
.hotclass.kqb-media-list {
  margin: 0 43px;
}

.doyoulike.kqb-media-list .kqb-media-item,
.hotclass.kqb-media-list .kqb-media-item {
  display: block;
  padding: 0;
  box-shadow: none;
}
.doyoulike.kqb-media-list {
  margin-bottom: 200px;
}
/* 热门课程 */
.hotclass.kqb-media-list {
  display: -webkit-flex;
  display: flex;
  -webkit-justify-content: space-between;
  justify-content: space-between;
  -webkit-flex-wrap: wrap;
  flex-wrap: wrap;
}

.hotclass.kqb-media-list .kqb-media-item {
  width: 48%;
  margin: 46px 0 0 0;
}

.hotclass.kqb-media-list .kqb-media-item .kqb-media-object {
  max-width: 100%;
  margin: 0;
  border: 1px solid #f9f9f9;
  border-radius: 10px;
  box-sizing: border-box;
}

.hotclass.kqb-media-list .kqb-media-item .kqb-media-inner .kqb-media-label {
  border: 0;
}

.hotclass.kqb-media-list .kqb-media-item .kqb-media-inner .kqb-media-title {
  margin: 18px 0 11px 0;
  font-size: 26px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
}

.hotclass.kqb-media-list .kqb-media-item .kqb-media-inner .kqb-media-desc,
.hotclass.kqb-media-list .kqb-media-item .kqb-media-inner .kqb-media-label {
  width: 100%;
  line-height: 1.1;
  margin: 0 0 22px 0;
  text-align: left;
  font-size: 22px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(170, 170, 170, 1);
}

.hotclass.kqb-media-list .kqb-media-item .kqb-media-inner .kqb-media-desc {
  margin: 0 0 11px 0;
  color: rgba(102, 102, 102, 1);
}

.hotclass.kqb-media-list
  .kqb-media-item
  .kqb-media-inner
  .kqb-media-footer
  div {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(170, 170, 170, 1);
}

.hotclass.kqb-media-list
  .kqb-media-item
  .kqb-media-inner
  .kqb-media-footer.fc-FF1A1A,
.hotclass.kqb-media-list
  .kqb-media-item
  .kqb-media-inner
  .kqb-media-footer
  div.fc-FF1A1A {
  font-size: 23px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: rgba(255, 26, 26, 1);
}

/*猜你喜欢*/
.doyoulike.kqb-media-list .kqb-media-item .kqb-media-object-group .mask {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 46px;
  padding: 0 17px;
  line-height: 46px;
  font-size: 24px;
  font-family: Microsoft YaHei;
  font-weight: 300;
  color: rgba(255, 255, 255, 1);
  background: rgba(0, 0, 0, 0.5);
}

.doyoulike.kqb-media-list .kqb-media-item .kqb-media-object {
  max-width: 100%;
  height: 367px;
  border-radius: 10px;
}

.doyoulike.kqb-media-list .kqb-media-inner .kqb-media-item .kqb-media-title {
  font-size: 28px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: rgba(0, 0, 0, 1);
}

.doyoulike.kqb-media-list .kqb-media-item .kqb-media-inner .kqb-media-footer {
  margin: 24px 0 0 0;
}

.doyoulike.kqb-media-list
  .kqb-media-item
  .kqb-media-inner
  .kqb-media-footer
  div.fc-000 {
  font-size: 28px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: rgba(0, 0, 0, 1);
}

.doyoulike.kqb-media-list
  .kqb-media-item
  .kqb-media-inner
  .kqb-media-footer
  div.fc-FF1A1A {
  font-size: 23px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: rgba(255, 26, 26, 1);
}

/*modal*/
.modal {
  z-index: 10;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
}

.BGurl-modal {
  width: 90%;
  height: 755px;
  margin: 36% 0 0 0;
  padding: 80px 0 0 50px;
  box-sizing: border-box;
}

.BGurl-modal .artword {
  max-width: 418px;
  height: 121px;
  margin: 0 auto;
}

.BGurl-modal .fc-875940 {
  max-width: 418px;
  margin: 26px auto 0 auto;
  font-size: 24px;
  font-family: SourceHanSansCN-Regular;
  font-weight: 400;
  color: rgba(135, 89, 64, 1);
}

.modal .nav-bar {
  width: 80%;
  margin: 43px auto 61px auto;
}

.modal .nav-bar .nav-bar-item {
  font-size: 26px;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(120, 72, 47, 1);
}

.modal .nav-bar .nav-bar-item img {
  max-width: 70px;
  height: 70px;
}

.modal .kqb-btn {
  position: absolute;
  bottom: 120px;
  left: 50%;
  width: 506px;
  height: 85px;
  margin: 0 auto;
  margin-left: 30px;
  border: 0;
  background: linear-gradient(
    90deg,
    rgba(219, 178, 146, 1) 0%,
    rgba(248, 223, 196, 1) 100%
  );
  box-shadow: 0px 10px 30px 0px rgba(0, 0, 0, 0.5);
  border-radius: 43px;
  transform: translate(-50%, 0);
}

.modal .kqb-btn text {
  font-size: 36px;
  font-family: MicrosoftYaHei-Bold;
  color: rgba(120, 72, 47, 1);
}

.modal .kqb-btn text:first-child {
  font-weight: bold;
}

.modal .icon-canel2 {
  position: absolute;
  bottom: -80px;
  left: 50%;
  color: #fff;
  margin-left: 30px;
  transform: translate(-50%, 0);
}

button.kqb-btn.fc-78482F {
  background-color: #78482f;
}

button.kqb-btn.fc-78482F span:first-child {
  font-size: 40px;
  font-weight: bold;
}

.share-button {
  position: fixed;
  bottom: 140px;
  right: 30px;
  width: 70px;
  height: 70px;
  border-radius: 50%;
}
</style>
<style>
/* 修改框架样式 */
.van-tabbar-item__icon img {
  width: auto;
  height: 29px !important;
}
</style>
